import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { getChangedFields } from '@shared/helpers/get-form-changed-fields';

@Injectable({ providedIn: 'root' })
export class DecedentValidationService {
  hasFieldError(form: UntypedFormGroup, field: string): boolean {
    const control = form.controls[field];
    return control.invalid && control.touched;
  }

  hasSpecificError(form: UntypedFormGroup, field: string, errorKey: string): boolean {
    return this.hasFieldError(form, field) && !!form.controls[field].errors?.[errorKey];
  }

  isDOBbeforeDODError(form: UntypedFormGroup): boolean {
    return (
      form.controls.isDOBbeforeDOD.invalid &&
      form.controls.isDOBbeforeDOD.touched &&
      !form.controls.dateOfDeath.invalid &&
      !form.controls.dateOfBirth.invalid
    );
  }

  shouldNavigateToReviewPage(form: UntypedFormGroup): boolean {
    const changedFields = getChangedFields(form);
    const conditions = [
      ['isDOBbeforeDOD'],
      ['zipCode', 'isDOBbeforeDOD'],
      ['dateOfDeath', 'isDOBbeforeDOD'],
      ['dateOfDeath', 'isDOBbeforeDOD', 'zipCode'],
    ];
    return conditions.some(
      (fields) =>
        changedFields.length === fields.length &&
        fields.every((field) => changedFields.includes(field)),
    );
  }
}
